import { render } from "./walletSystems.vue?vue&type=template&id=d0aaa9ac&scoped=true"
import script from "./walletSystems.vue?vue&type=script&lang=js"
export * from "./walletSystems.vue?vue&type=script&lang=js"

import "./walletSystems.vue?vue&type=style&index=0&id=d0aaa9ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0aaa9ac"]])

export default __exports__